import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { BenchUser } from '@root/globalTypes';

export function useGet(id: string) {
  const { query } = useApi();

  const { data, isPending } = useQuery<BenchUser>({
    queryKey: [...queryKeys.benchUsers, id],
    queryFn: (): Promise<BenchUser> =>
      query({
        path: `v1/staff/bench_users/${id}`,
      }),
    enabled: Boolean(id),
  });

  return {
    data: data,
    isPending,
  };
}
